import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Stream from 'flarum/utils/Stream';
import Select from 'flarum/common/components/Select';
import Button from 'flarum/components/Button';
import LoadingIndicator from "flarum/components/LoadingIndicator";

import InfoImportSuccessModal from './InfoImportSuccessModal';
import LocationSelectModal from './LocationSelectModal';
import setInputError from "../../common/util/setInputError";
import showAlert from '../../common/util/showAlert';
import * as XLSX from 'xlsx';

export default class InfoSubmitModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    this.wrapData = this.attrs.wrapData;
    this.loading = false;
    this.importMode = false;
    this.importDataList = [];
    this.importing = false;
    this.importCount = 0;
    this.importComplete = false;

    if(this.wrapData.initType==="add"){
      this.option_zclb = Stream("zzyd");
      this.option_zcwz = Stream({position:null,name:null,city:null});
      this.option_cjjg = Stream("");
    }else if(this.wrapData.initType==="resume"){
      this.option_zclb = Stream(this.wrapData.option_zclb());
      this.option_zcwz = Stream(this.wrapData.option_zcwz());
      this.option_cjjg = Stream(this.wrapData.option_cjjg());
    }
  }

  onImportButtonReady() {
    const _this = this;
    $("#u2diImportInfoButton").on('change',async function(e){
      const file = e.target.files[0];

      if(file){
        const data = await file.arrayBuffer();
        const workbook = XLSX.read(data);
        const sheets = workbook.Sheets;
        _this.importDataList = [];

        for(let index in sheets){
          const sheetData = sheets[index];
          let startRow = 3;

          while(sheetData["A"+startRow]){
            _this.importDataList.push({
              zcxz:sheetData["A"+startRow].h,
              cjjg:sheetData["B"+startRow].v,
              zcwz:sheetData["C"+startRow].h,
            });

            startRow++;
          }
        }

        _this.importMode = true;
        m.redraw();
      }
    });
  }

  className() {
    return 'Modal--small';
  }

  title() {
    if(this.importMode===true){
      return app.translator.trans('ziven-u2di.forum.button-import-info');
    }else{
      return app.translator.trans('ziven-u2di.forum.title-import-info');
    }
  }

  content() {
    if(this.importMode===false){
      let zclbOptions = {};
      zclbOptions["zzyd"] = app.translator.trans('ziven-u2di.forum.option-zclb-zzyd');
      zclbOptions["syyd"] = app.translator.trans('ziven-u2di.forum.option-zclb-syyd');
      zclbOptions["gyyd"] = app.translator.trans('ziven-u2di.forum.option-zclb-gyyd');
      zclbOptions["wlcc"] = app.translator.trans('ziven-u2di.forum.option-zclb-wlcc');
      zclbOptions["syjz"] = app.translator.trans('ziven-u2di.forum.option-zclb-syjz');
      zclbOptions["gyjz"] = app.translator.trans('ziven-u2di.forum.option-zclb-gyjz');
      zclbOptions["wlck"] = app.translator.trans('ziven-u2di.forum.option-zclb-wlck');
      zclbOptions["nzjd"] = app.translator.trans('ziven-u2di.forum.option-zclb-nzjd');

      return (
        <div className="Modal-body u2diSubmitModalBody">
          <div className="Form-group">
            <div className="u2diInfoSubmitContainer">
              <div style="text-align: center;padding-bottom: 20px;">
                <label style="cursor:pointer" for="u2diImportInfoButton" className="btn">{app.translator.trans('ziven-u2di.forum.button-import-info')}</label>
                <input required oncreate={this.onImportButtonReady.bind(this)} id="u2diImportInfoButton" style="display:none;" type="file" />
              </div>

              <div className="u2diUserSubmitCategoryItems">
                <div className="u2diUserSubmitCategoryItemName">
                  {app.translator.trans('ziven-u2di.forum.user-submission-category-item-cjjg')}
                </div>
                <div className="u2diUserSubmitCategoryItemOptions">
                  <input required id="option_cjjg" disabled={this.loading} className="FormControl u2diUserSubmitCategoryItemInput" type="number" step="0.001" min="0.001" bidi={this.option_cjjg} />
                  <span className="u2diUserSubmitCategoryItemUnit">{app.translator.trans('ziven-u2di.lib.unit-10k-per-mu')}</span>
                </div>
              </div>

              <div className="u2diUserSubmitCategoryItems">
                <div className="u2diUserSubmitCategoryItemName">
                  {app.translator.trans('ziven-u2di.forum.user-submission-category-item-zclb')}
                </div>
                <div className="u2diUserSubmitCategoryItemOptions">
                  <Select className="u2diDataSelectList" value={this.option_zclb()}
                    disabled={this.loading}
                    options={zclbOptions}
                    onchange={(e) => { this.option_zclb(e); }}
                  />
                </div>
              </div>

              <div style="align-items: flex-start;" className="u2diUserSubmitCategoryItems">
                <div style="padding-top: 5px;" className="u2diUserSubmitCategoryItemName">
                  {app.translator.trans('ziven-u2di.forum.user-submission-category-item-zcwz')}
                </div>
                <div style="padding-top: 5px;padding-bottom: 10px;" className="u2diUserSubmitCategoryItemOptions">
                  {!this.option_zcwz().name && (
                    <div id="option_zcwz" className="u2diLink" onclick={(e) => { this.selectMapPosition() }}>
                      {app.translator.trans('ziven-u2di.forum.option-zcwz-select-location')}
                    </div>  
                  )}

                  {this.option_zcwz().name && (
                    <div style="display: flex;">
                      <div style="max-width: 190px;" className="u2diLinkType2 u2diEllipsisArea" onclick={(e) => { this.selectMapPosition() }}>
                        {this.option_zcwz().name}
                      </div>
                      &nbsp;<i style="margin-top: 3px;" class="fas fa-th-large-marker-alt"></i>
                    </div>
                  )}
                </div>
              </div>

              <div className="u2diManagementButtonsContainer" style="text-align: center;padding-top: 20px;">
                {Button.component({
                    style:"min-width:66px;",
                    disabled: this.loading,
                    type: 'submit',
                    className: 'Button Button--primary',
                    onclick: (e) => {
                      this.submitData(e)
                    }
                  },
                  app.translator.trans('ziven-u2di.lib.save')
                )}
                &nbsp;
                {Button.component({
                    style:"min-width:66px;",
                    className: 'Button U2DiButton--gray',
                    disabled: this.loading,
                    onclick: () => {
                      this.hide();
                    }
                  },
                  app.translator.trans('ziven-u2di.lib.cancel')
                )}
              </div>
            </div>
          </div>
        </div>
      );
    }else{
      const loading = LoadingIndicator.component({ size: "small" });
      let importID = 0;

      return (
        <div style="padding:0px 15px 30px 20px" className="Modal-body u2diSubmitModalBody">
          <div className="Form-group">
            <div className="u2diInfoImportContainer">
              {this.importing===true && this.importComplete===false && (
                <div style="text-align: center;padding-bottom: 20px;font-size: 16px;">{app.translator.trans('ziven-u2di.forum.info-importing',{importCount:this.importCount+1,count:(this.importDataList).length})}</div>
              )}

              {this.importing===true && this.importComplete===true && (
                <div style="text-align: center;padding-bottom: 20px;font-size: 16px;">{app.translator.trans('ziven-u2di.forum.info-import-complete',{successCount:$(".u2diInfoImportPassed").length,failedCount:$(".u2diInfoImportFailed").length})}</div>
              )}

              {this.importing===false && (
                <div style="text-align: center;padding-bottom: 20px;font-size: 16px;">{app.translator.trans('ziven-u2di.forum.info-import-confirmation',{count:(this.importDataList).length})}</div>
              )}

              <div style="color: var(--text-color);font-weight: bold;" className="u2diInfoImport">
                <div>{app.translator.trans('ziven-u2di.forum.item-import-zcxz')}</div>
                <div>{app.translator.trans('ziven-u2di.forum.item-import-cjjg')}</div>
                <div>{app.translator.trans('ziven-u2di.forum.item-import-zcwz')}</div>
              </div>
              <div id="importDataListContainer" style="max-height: 400px;overflow-y: auto;">
                {this.importDataList.map((data) => {
                  const zcxz = data.zcxz;
                  const cjjg = data.cjjg;
                  const zcwz = data.zcwz;

                  importID++;

                  return (
                    <div id={"importID"+importID} className="u2diInfoImport">
                      <div>{zcxz}</div>
                      <div>{cjjg} {app.translator.trans('ziven-u2di.lib.unit-10k-per-mu')}</div>
                      <div className="u2diEllipsisArea">{zcwz}</div>
                    </div>
                  );
                })}
              </div>
            </div>

            {this.importing===false && (
              <div className="u2diManagementButtonsContainer" style="text-align: center;padding-top: 20px;">
                {Button.component({
                    style:"min-width:66px;",
                    disabled: this.loading,
                    className: 'Button Button--primary',
                    onclick: (e) => {
                      this.importDataConfirm(e)
                    }
                  },
                  app.translator.trans('ziven-u2di.lib.confirm')
                )}
                &nbsp;
                {Button.component({
                    style:"min-width:66px;",
                    className: 'Button U2DiButton--gray',
                    disabled: this.loading,
                    onclick: () => {
                      this.importMode = false;
                      this.importDataList = [];
                      m.redraw();
                    }
                  },
                  app.translator.trans('ziven-u2di.lib.cancel')
                )}
              </div>
            )}

            {this.importing===true && this.importComplete===true && (
              <div className="u2diManagementButtonsContainer" style="text-align: center;padding-top: 20px;">
                {Button.component({
                    style:"min-width:66px;",
                    disabled: this.loading,
                    className: 'Button Button--primary',
                    onclick: (e) => {
                      this.importMode = false;
                      this.importing = false;
                      this.importComplete = false;
                      m.redraw();
                    }
                  },
                  app.translator.trans('ziven-u2di.lib.back')
                )}
              </div>
            )}
          </div>
        </div>
      );

    }
  }

  getWrapData(){
    return {
      returnModal: "InfoSubmitModal",

      option_zclb:this.option_zclb,
      option_zcwz:this.option_zcwz,
      option_cjjg:this.option_cjjg,
    }
  }

  selectMapPosition() {
    const wrapData = this.getWrapData();
    app.modal.show(LocationSelectModal,{wrapData});
  }

  checkSubmitData(){
    const wrapData = this.getWrapData();
    let isValid = true;

    for(let index in wrapData){
      if(typeof(wrapData[index])!=="function"){
        continue;
      }

      if((wrapData[index]()).length===0 && $("#"+index).length>0 && $("#"+index).prop('disabled')!==true){
        setInputError("#"+index,isValid);
        isValid = false;
      }
    }

    if(this.option_zcwz().position===null){
      setInputError("#option_zcwz",isValid);
      isValid = false;
    }

    return isValid;
  }

  importDataConfirm(e) {
    this.importing = true;
    this.importCount = 0;
    $(".Modal-close").hide();
    m.redraw();

    this.initImport(0);
  }

  initImport(importID){
    if(importID===this.importDataList.length){
      this.importComplete = true;
      $(window).trigger('u2diInfoAdd');
      $(window).trigger('refreshNotification');
      $(".Modal-close").show();
      m.redraw();
      return;
    }

    m.redraw();

    const _this = this;
    const importContainerID = "#importID"+(importID+1);
    const importData = this.importDataList[importID];
    const placeName = importData.zcwz;
    $(importContainerID).addClass("u2diInfoImportChecking");

    $(window).trigger('searchPlace', {
      placeName: placeName,
      callback: function(result){
        $(importContainerID).removeClass("u2diInfoImportChecking");
        const info = result.info;

        if(info==="OK"){
          $(importContainerID).addClass("u2diInfoImportPassed");

          const pois = result.poiList.pois;
          const addressReg = /.+?(省|市|自治区|自治州|县|区)/g;

          if(pois.length>0){
            const poisLocation = pois[0].location;
            const lat = poisLocation.lat;
            const lng = poisLocation.lng;
            const addressSeperate = placeName.match(addressReg);
            const province = addressSeperate[0];
            const city = addressSeperate[1];

            let selectedType = _this.getImportDataType(importData.zcxz);
            let selectedCategory = ["zzyd","syyd","gyyd","wlcc"].indexOf(selectedType)!==-1?"tdwz":"jzwz";

            const submitData = {
              base:{
                position:{position:{lng:lng,lat:lat},name:importData.zcwz,city:null},
                price: importData.cjjg,
                province: province,
                city: city,
                size: 0,
                category: selectedCategory,
                type:selectedType
              },
            };

            _this.initImportComplete(importID,"u2diInfoImportPassed",function(){
                app.request({
                  url: `${app.forum.attribute('apiUrl')}/u2diInfoBase/import`,
                  method: 'POST',
                  body:{importData:submitData},
                }).then((returnData) => {
                  _this.initImport(_this.importCount);
                }, error => {
                  this.loading = false;
                });
            });
          }else{
            _this.initImportComplete(importID,"u2diInfoImportFailed",function(){
              _this.initImport(_this.importCount);
            });
          }
        }else{
          _this.initImportComplete(importID,"u2diInfoImportFailed",function(){
            _this.initImport(_this.importCount);
          });
        }
      }
    });
  }

  initImportComplete(importID,result,callback){
    const _this = this;
    const importContainerID = "#importID"+(importID+1);

    $(importContainerID).addClass(result);
    $("#importDataListContainer").animate({scrollTop: (-9+importID)*25.5}, { duration: 330, 
      complete:function () {
        _this.importCount++;

        if(typeof(callback)==="function"){
          callback();
        }
      }
    });
  }

  getImportDataType(zcxz){
    let output = "";
    if(zcxz.indexOf("居住用地")!==-1){ output = "zzyd"; }
    if(zcxz.indexOf("商业用地")!==-1){ output = "syyd"; }
    if(zcxz.indexOf("工业用地")!==-1){ output = "gyyd"; }
    if(zcxz.indexOf("仓储物流")!==-1){ output = "wlcc"; }
    if(zcxz.indexOf("商办建筑")!==-1){ output = "syjz"; }
    if(zcxz.indexOf("工业建筑")!==-1){ output = "gyjz"; }
    if(zcxz.indexOf("物流仓库")!==-1){ output = "wlck"; }
    if(zcxz.indexOf("农宅基地")!==-1){ output = "nzjd"; }

    return output;
  } 

  submitData(e) {
    e.preventDefault();

    if(this.checkSubmitData()===false){
      showAlert(app.translator.trans('ziven-u2di.forum.error-input-empty'));
      return;
    }

    let selectedCategory = ["zzyd","syyd","gyyd","wlcc"].indexOf(this.option_zclb())!==-1?"tdwz":"jzwz";
    
    const submitData = {
      base:{
        position:this.option_zcwz(),
        price: this.option_cjjg(),
        size: 0,
        category: selectedCategory,
        type:this.option_zclb()
      },
    };

    app.request({
      url: `${app.forum.attribute('apiUrl')}/u2diInfoBase/import`,
      method: 'POST',
      body:{importData:submitData},
    }).then((returnData) => {
        app.modal.show(InfoImportSuccessModal,{returnData});
        $(window).trigger('u2diInfoAdd');
        $(window).trigger('refreshNotification');
    }, error => {
      this.loading = false;
    });

  }
}
